module.exports = __webpack_public_path__ + "static/media/memvra-3.aa1ed8f5.png";